

const ScheduledTriggerRuleForm = () => {
  return <></>
}

export default ScheduledTriggerRuleForm
